import React from 'react';

const Badge = ({
  children,
  variant = 'gray',
  className = '',
  icon,
  ...props
}) => {
  return (
    <span className={`badge badge-${variant} ${className}`.trim()} {...props}>
      {icon && <span className="badge-icon">{icon}</span>}
      {children}
    </span>
  );
};

export default Badge;
